var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "highlightIconChart" },
    [
      _c("div", { staticClass: "highlightIconChart__background hideMobile" }),
      _vm._v(" "),
      _c("div", { staticClass: "panelCard highlightIconChart__wrapper" }, [
        _c("div", { staticClass: "padding-all-10" }, [
          _c(
            "h5",
            {
              staticClass:
                "highlightChart__title hl-module text-color--dark-blue-gray",
            },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.chartTitle) + "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { class: { "padding-vertical-10": _vm.isMinContent } }, [
            _c(
              "div",
              { staticClass: "highlightIconChart__wrapper--content" },
              _vm._l(_vm.sortedKeyPlayers, function (keyPlayer, index) {
                return _c("div", { key: index }, [
                  _c(
                    "object",
                    {
                      staticClass:
                        "highlightIconChart__wrapper--playerImg vertical-middle margin-right-10",
                      class: { "margin-bottom-10": _vm.isLastPlayer(index) },
                      attrs: {
                        type: "image/png",
                        data: _vm.getCdnLink(
                          `icons/xmo/company_logos/${keyPlayer.iconPath}.svg`
                        ),
                      },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "highlightChart__title hl-module text-color--gray-blue margin-bottom-0",
                          class: _vm.getPlaceholderClass(keyPlayer.name),
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(keyPlayer.name) +
                              "\n                            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasNextChart
        ? _c("NextChartButton", {
            attrs: {
              "section-chart-data": _vm.sectionChartData,
              "is-disabled": _vm.isNextButtonDisabled,
            },
            on: { "set-chart-selection": _vm.changeKeyPlayers },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }